import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from '@/components/ui/Card';
import { RideSearchForm } from '@/features/rides/components/RideSearchForm';
import { toSearchParams } from '@/features/rides/schemas/rideSearch';

export function HomePage() {
  const navigate = useNavigate();

  return (
    <>
      <section className="bg-gradient-to-b from-brand-50 to-slate-50">
        <div className="mx-auto max-w-6xl px-4 pb-10 pt-12 sm:px-6 sm:pb-14 sm:pt-20">
          <div className="max-w-2xl">
            <h1 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
              Going somewhere?{' '}
              <span className="text-brand-700">Take someone with you.</span>
            </h1>
            <p className="mt-4 text-lg text-slate-600">
              WeDrive connects drivers with empty seats to passengers heading the same way.
              Share the journey, split the cost.
            </p>
          </div>

          <Card className="mt-8 shadow-raised sm:mt-10">
            <CardBody>
              <RideSearchForm
                onSearch={(values) => navigate(`/search?${toSearchParams(values).toString()}`)}
              />
            </CardBody>
          </Card>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="grid gap-6 sm:grid-cols-3">
          {[
            {
              title: 'Pick your route',
              body: 'Search by where you are leaving from, where you are going, and when.',
            },
            {
              title: 'Book a seat',
              body: 'Request a seat and the driver confirms. Seats are held the moment you book.',
            },
            {
              title: 'Travel and review',
              body: 'Meet at the pickup point, share the cost, then rate each other afterwards.',
            },
          ].map((step, index) => (
            <Card key={step.title}>
              <CardBody>
                <span className="inline-flex size-8 items-center justify-center rounded-full bg-brand-100 text-sm font-semibold text-brand-800">
                  {index + 1}
                </span>
                <h2 className="mt-3 font-semibold text-slate-900">{step.title}</h2>
                <p className="mt-1 text-sm text-slate-600">{step.body}</p>
              </CardBody>
            </Card>
          ))}
        </div>
      </section>
    </>
  );
}
